import { ComponentDesign, ManualLoadSettings, MovingLoadSettings } from '@paragon/contract-library';

import { setAdditionalLoads } from '../slices/componentDesignsSlice';
import { ThunkActionVoid } from './thunkActions';

export const editMovingLoadInComponentDesign =
  (componentDesign: ComponentDesign, movingLoadSettings: MovingLoadSettings): ThunkActionVoid =>
  (dispatch) => {
    if (componentDesign.additionalLoads == null) {
      console.error('Unable to edit moving loads because componentDesign.additionalLoads is null');
      return;
    }

    const movingLoadSettingsIndex = componentDesign.additionalLoads.movingLoadSettings.findIndex(
      (settings) => settings.guid === movingLoadSettings.guid,
    );
    if (movingLoadSettingsIndex === -1) throw new Error('Moving load to edit not found');
    const newMovingLoadSettings = [...componentDesign.additionalLoads.movingLoadSettings];
    newMovingLoadSettings[movingLoadSettingsIndex] = movingLoadSettings;
    const newAdditionalLoads = { ...componentDesign.additionalLoads, movingLoadSettings: newMovingLoadSettings };

    dispatch(setAdditionalLoads({ additionalLoads: newAdditionalLoads, componentDesignGuid: componentDesign.guid }));
  };

export const editManualLoadInComponentDesign =
  (componentDesign: ComponentDesign, manualLoadSettings: ManualLoadSettings): ThunkActionVoid =>
  (dispatch) => {
    if (componentDesign.additionalLoads == null) {
      console.error('Unable to edit manual loads because componentDesign.additionalLoads is null');
      return;
    }

    const manualLoadSettingsIndex = componentDesign.additionalLoads.manualLoadSettings.findIndex(
      (settings) => settings.guid === manualLoadSettings.guid,
    );
    if (manualLoadSettingsIndex === -1) throw new Error('Manual load to edit not found');
    const newManualLoadSettings = [...componentDesign.additionalLoads.manualLoadSettings];
    newManualLoadSettings[manualLoadSettingsIndex] = manualLoadSettings;
    const newAdditionalLoads = { ...componentDesign.additionalLoads, manualLoadSettings: newManualLoadSettings };

    dispatch(setAdditionalLoads({ additionalLoads: newAdditionalLoads, componentDesignGuid: componentDesign.guid }));
  };
